import React from 'react';

const Rating = ({ rating }) => (
  <div className="rating">
    <span className='number-rating'>{rating}</span>
    <div className="stars">
      {Array.from({ length: Math.ceil(rating) }, (_, index) => (
        <span key={index} className={index < rating ? 'star filled' : 'star'}>★</span>
      ))}
    </div>
  </div>
);

export default Rating;
